const user = {
  state: {
    userInfo: null,
    isNested: false
  },
  mutations: {
    SET_IS_NESTED: (state, roles) => {
      localStorage.setItem("isNested", roles ? "1" : "0");
      state.isNested = roles;
    },
    SET_USER_INFO: (state, roles) => {
      if (typeof roles == 'string') {
        roles = JSON.parse(roles||"{}");
      }
      localStorage.setItem("userInfo", JSON.stringify(roles));
      state.userInfo = roles;
    },
    LOGOUT_MOVE_USER_INFO: (state) => {
      localStorage.removeItem("userInfo");
      localStorage.removeItem("vic_mall");
      localStorage.removeItem("vayHub");
      state.userInfo = null;
    }
  }
};

export default user;
